import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import Input from "../../../Components/Utils/Input";
import Button from "../../../Components/Utils/Button";
import * as Yup from "yup";
import Alert from "../../../Components/Utils/Alert";
import messageSlice from "../../../Redux/MessageSlice";
import BaseApi from "../../../Http/BaseApi";
import { toast } from "react-toastify";
import MathCaptchaField from "../../../Components/Utils/MathCaptchaField";

export default function ForgetPassword() {
  const [formRole, setFormRole] = useState("forget");
  const [initialValues, setInitialValues] = useState();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetContext, setResetContext] = useState({
    username: "",
    otp: "",
  });
  const [captchaState, setCaptchaState] = useState({
    captcha: "",
    captcha_key: "",
  });
  const [captchaNonce, setCaptchaNonce] = useState(0);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const panel =
    searchParams.get("panel") === "department" ? "department" : "staff";

  useEffect(() => {
    dispatch(messageSlice.actions.clearMessage());
    if (isLoggedIn) {
      navigate("/dashboard");
      window.location.reload();
    }
    setInitialValues({
      username: "",
      otp: "",
      new_password: "",
      confirm_password: "",
      panel,
    });
  }, [dispatch, panel]);

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("This field is required!"),
  });

  const handleSubmit = async (payload) => {
    dispatch(messageSlice.actions.clearMessage());
    setLoading(true);
    if (formRole === "forget") {
      try {
        const requestPayload = {
          ...payload,
          panel,
          username: payload.username || resetContext.username,
          otp: payload.otp || resetContext.otp,
        };

        if (!isOtpSent) {
          requestPayload.captcha = captchaState.captcha;
          requestPayload.captcha_key = captchaState.captcha_key;
        }

        const response = await BaseApi(panel).post(
          "/forgot-password",
          requestPayload
        );
        var step = response.data?.step;

        if (step == 1) {
          setResetContext((prev) => ({
            ...prev,
            username: requestPayload.username,
          }));
          setIsOtpSent(true);
        }
        if (step == 2) {
          setResetContext({
            username: requestPayload.username,
            otp: requestPayload.otp,
          });
          setIsOtpSent(true);
          setIsOtpVerified(true);
        }
        if (step == 3) {
          setIsOtpSent(false);
          setIsOtpVerified(false);
          setResetContext({ username: "", otp: "" });
          setInitialValues({
            username: "",
            otp: "",
            new_password: "",
            confirm_password: "",
            panel,
          });
          navigate(`/`);
        }

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: undefined,
        });
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: undefined,
        });
        if (!isOtpSent) {
          setCaptchaState({ captcha: "", captcha_key: "" });
          setCaptchaNonce((n) => n + 1);
        }
      }
    }

    setLoading(false);
    setFormRole("forget");
  };

  return (
    <>
      <div className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8  mt-10'>
        <div className='max-w-md w-full space-y-8 shadow-2xl p-10 rounded-lg'>
          <div>
            <img
              className='mx-auto h-12 w-auto rounded-full'
              src='https://erp.dibru.work/images/dibru.png'
              alt='Logo'
            />

            <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-600'>
              Dibrugarh University Accounts
            </h2>
            <h2 className='mt-1 text-center text-xl font-medium text-gray-600'>
              Password Reset
            </h2>
          </div>
          {message && <Alert message={message} />}

          {initialValues && (
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                <div className='  -space-y-px'>
                  <div className=''>
                    {isOtpSent != true && (
                      <Input
                        readOnly={isOtpSent ? true : false}
                        showInput={isOtpSent ? "show" : "hide"}
                        label='Registered Email/Contact Number'
                        name='username'
                        placeholder='Enter your registered Email ID or Contact Number'
                      />
                    )}
                  </div>
                </div>

                {isOtpSent != true && (
                  <MathCaptchaField
                    key={captchaNonce}
                    panel={panel}
                    value={captchaState}
                    onChange={setCaptchaState}
                  />
                )}

                {isOtpSent == true && (
                  <>
                    <div className='  -space-y-px'>
                      <div className=''>
                        {isOtpVerified != true && (
                          <Input
                            showInput={isOtpSent ? "show" : "hide"}
                            readOnly={isOtpVerified ? true : false}
                            label='OTP'
                            name='otp'
                            type='number'
                            placeholder='Enter the OTP'
                          />
                        )}
                      </div>
                    </div>
                  </>
                )}

                {isOtpVerified == true && (
                  <>
                    <div className='  -space-y-px'>
                      <div className=''>
                        <Input
                          label='New Password'
                          type='password'
                          name='new_password'
                          placeholder='New Password'
                        />
                      </div>
                    </div>

                    <div className='  -space-y-px'>
                      <div className=''>
                        <Input
                          type='password'
                          label='Confirm Password'
                          name='confirm_password'
                          placeholder='Confirm Password'
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className='text-left mt-5'>
                  <Button
                    value={loading ? "Submitting..." : "Submit"}
                    icon={"SaveIcon"}
                    type='submit'
                  />
                </div>
              </Form>
            </Formik>
          )}
        </div>
      </div>
    </>
  );
}
